const API_URL = 'https://bm69mhu1ze.execute-api.us-east-1.amazonaws.com/addToSession'

export async function validateSession(sessionId: string): Promise<{ valid: boolean; error?: string }> {
    const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'validateSession', sessionId }),
    })
    const body = await res.json()
    if (res.ok) return { valid: true }
    return { valid: false, error: body.error ?? 'Invalid session' }
}

export async function addToSession(
    sessionId: string,
    trackAsin: string,
    trackTitle: string
): Promise<{ success: boolean; message: string }> {
    const guestName = sessionStorage.getItem('partyGuestName') ?? 'Someone'
    const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'addToSession', sessionId, trackAsin, guestName, trackTitle }),
    })
    const body = await res.json()
    if (res.ok) return { success: true, message: body.message ?? 'Added!' }
    return { success: false, message: body.error ?? 'Failed to add track' }
}

export function getSessionId(): string | null {
    return new URLSearchParams(window.location.search).get('s')
}
